var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('page-with-button',{attrs:{"title":"Your interview is booked","subtitle":"You'll get an email reminding you of the date and time","titleDescription":"We look forward to getting to know you.","textDescription":`Tips for a successful interview:
      •  Test your audio and video before the interview
      •  Make sure your internet connection has good bandwidth before joining
      •  We're going to ask you about your nursing experience, be prepared!
      \nSee you soon,
      The CareSend Team`,"img":require('@/assets/logo.png'),"icon":"video"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }